import React from "react";
import Navbar from "../../../Navbar/Navbar";
import WakelSecond from "./WakelSecond";

const InputWakel = () => {
  return (
    <>
      <Navbar />
      <div className="mt5"></div>

      <WakelSecond />
    </>
  );
};

export default InputWakel;
